/**
 * Version / update-check helpers.
 *
 * - APP_VERSION es inyectado por Vite en build time desde package.json.
 * - checkForUpdate() fetchea /version.json (cache-bust) y compara.
 * - applyUpdate() limpia caches + desregistra SW + recarga.
 */

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev';
export const BUILD_TIME = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '';

export function compareVersions(a, b) {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] || 0, y = pb[i] || 0;
    if (x > y) return 1;
    if (x < y) return -1;
  }
  return 0;
}

export async function checkForUpdate() {
  const url = `/version.json?t=${Date.now()}`;
  try {
    const r = await fetch(url, { cache: 'no-store' });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const remote = await r.json();
    const cmp = compareVersions(remote.version || '0.0.0', APP_VERSION);
    return {
      ok: true,
      hasUpdate: cmp > 0,
      currentVersion: APP_VERSION,
      remoteVersion: remote.version,
      remoteBuildTime: remote.buildTime,
    };
  } catch (e) {
    return { ok: false, error: e.message, currentVersion: APP_VERSION };
  }
}

export async function applyUpdate() {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    }
  } catch (e) {
    console.warn('[update] cleanup error', e);
  }
  // Hard reload (bypass cache)
  window.location.reload(true);
}

if (typeof window !== 'undefined') {
  window.APP_VERSION = APP_VERSION;
}
